var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "form-item col-1"
  }, [_c("div", [!_vm.is_data_set && _vm.type !== "subject" ? [_c("a-button", {
    staticClass: "button-add",
    attrs: {
      size: "large",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.dialogShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("com.selectGoodsData")) + " ")])] : [_c("div", {
    staticClass: "form-goods"
  }, [_c("a-textarea", {
    attrs: {
      disabled: true,
      value: _vm.tips,
      size: "large",
      "data-id": _vm.dataid
    }
  }), _c("a-button", {
    staticClass: "button-edit",
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.dialogShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("com.look")) + " ")])], 1)]], 2), _vm.dialogShow ? _c("goods-source-manager", {
    ref: "goodsSourceManager",
    attrs: {
      visible: _vm.dialogShow
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogShow = $event;
      },
      confirm: _vm.handle_dialog_confirm,
      add: _vm.handleGoodsAdd,
      delete: function _delete(r) {
        return _vm.$emit("goodsdelete", r);
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };